import { all, takeEvery, put } from 'redux-saga/effects'
import { request } from '../../../../admincore'

import { getActiveOrders } from '../../api'
import actions, { load } from './actions'

// const getCompanySelect = state => state.companySelect

let cachedParams = null

function* LOAD({ payload: { params } }) {
  cachedParams = params
  const companySelect = localStorage.getItem('app.settings.company')

  if (!companySelect || companySelect === -1) {
    return
  }

  yield put(request(getActiveOrders(companySelect, params), actions.LOAD))
}

function* COMPANY_SET() {
  if (cachedParams) {
    yield put(load(cachedParams))
  }
}

export default function* rootSaga() {
  yield all([takeEvery(actions.LOAD, LOAD), takeEvery('company/save', COMPANY_SET)])
}
